import { Download, ImportContacts } from "@mui/icons-material";
import { styled, Tooltip } from "@mui/material";
import { StyledButton } from "components/StyledButton";
import { unparse } from "papaparse";
import React from "react";

const SCHOOL = "Swinburne University of Technology";

const TEMPLATE_ROWS = [
    ["Alice", "Smith", "alice.smith@example.com", SCHOOL, "alice.smith@example.com"],
    ["Bob", "Jones", "bob.jones@example.com", SCHOOL, "bob.jones@example.com"],
    ["Carol", "White", "carol.white@example.com", SCHOOL, "carol.white@example.com"],
    ["David", "Brown", "david.brown@example.com", SCHOOL, "david.brown@example.com"],
    ["Emma", "Davis", "emma.davis@example.com", SCHOOL, "emma.davis@example.com"],
];

const TEMPLATE_HEADERS = ["firstName", "lastName", "email", "school", "password"];

const Input = styled("input")({
    display: "none",
});

export interface CreateAccountsPageImportCSVProps {
    addAccountsFromCSV: (files: File[]) => void;
}

export const CreateAccountsPageImportCSV = ({
    addAccountsFromCSV,
}: CreateAccountsPageImportCSVProps): JSX.Element => {
    const handleImport = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { files } = event.target;

        if (files === null) {
            return;
        }

        addAccountsFromCSV(Array.from(files));
    };

    const downloadTemplate = (): void => {
        const csv = unparse({ fields: TEMPLATE_HEADERS, data: TEMPLATE_ROWS });
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "students_template.csv");
        link.click();
    };

    return (
        <>
            <Tooltip title="Download CSV template">
                <StyledButton
                    variant="outlined"
                    color="secondary"
                    size="medium"
                    startIcon={<Download />}
                    sx={{ minWidth: 180, marginLeft: 2, marginRight: 2, whiteSpace: "nowrap" }}
                    onClick={downloadTemplate}
                    data-testid="download-template-btn"
                >
                    Download template
                </StyledButton>
            </Tooltip>

            <Tooltip title="Upload CSV">
                <label htmlFor="csvUpload">
                    <Input
                        accept="csv/*"
                        id="csvUpload"
                        type="file"
                        onChange={handleImport}
                    />
                    <StyledButton
                        component="span"
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        startIcon={<ImportContacts />}
                        sx={{ minWidth: 150 }}
                    >
                        Import CSV
                    </StyledButton>
                </label>
            </Tooltip>
        </>
    );
};
